import React, { useState } from "react";
import { Button, Menu, MenuItem, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { TaskStatuses } from "./utils";

const TaskStatus = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currentStatus = TaskStatuses.find((status) => status.value === value);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue && newValue !== value) {
      onChange(newValue);
    }
  };

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon className="text white" />}
        sx={{
          backgroundColor: currentStatus?.bgColor || "#ccc",
          fontSize: "0.72rem",
          height: 28,
          minWidth: "5.2rem",
          textTransform: "none",
          "& .MuiButton-endIcon": {
            marginLeft: "2px", // Modyfikuj lewy margines
          },
          "&:hover": {
            backgroundColor: currentStatus?.bgColor || "#bbb",
          },
        }}
      >
        <span sx={{ marginRight: 0 }} className="text white">
          {currentStatus?.label || "Nieznany"}
        </span>
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose()}>
        {TaskStatuses.map((status) => (
          <MenuItem
            key={status.value}
            onClick={() => handleClose(status.value)}
            selected={status.value === value}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: status.bgColor,
                display: "inline-block",
                marginRight: 1,
              }}
            />
            {status.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TaskStatus;
